import React from 'react';
import { TwoColScrollLayout, FlowStripeWrapper, TwoColStickyLayout, TwoColContentLayout, ContentContainer, ContentWrapper, SubNavigationWrapper } from '@flow/components/ui';
import styled from 'styled-components';
import TicketLift from '@flow/scenes/tickets/components/ticketLift/TicketLift';
import em from 'polished/lib/helpers/em';
import FlowStripe from '@flow/components/ticker/FlowStripe';
import { withRouteData } from 'react-static';
import * as NavigationAction from '@flow/store/navigation/actions';
import { connect } from 'react-redux';
import { ITicket } from 'types/ITicket';
import { getHashLink } from '@flow/utils/cleaners';
import SEOTags from '@flow/components/seo/SEOTags';
import { IPage } from 'types/IPage';
import LinkButton from '@flow/components/ui/button/LinkButton';
import { renderImageCarousel } from '@flow/scenes/default/ui';
import SimpleCarousel from '@flow/components/carousel/SimpleCarousel';

const Header = styled.header`
  text-align: center;
  margin-bottom: 6em;
  
  .dingbats {
    font-size: 8.8em;
    letter-spacing: ${em(1, 8.8)};
  }
`;

const HeaderTitle = styled.h1`
  font-family: Flow-Inverted;
  font-size: 10em;
  margin-top: ${em(6.8, 10)};
`;

const TicketCategory = styled.div`
  //margin-bottom: 7em;
  padding-top: 7em;
`;

const TicketTypeDescription = styled.div`
  margin-bottom: 7.8em;
  
  h2 {
    text-align: center;
  }
`;

const Ticket = styled.li`
  width: 32%;
  margin-right: 2%;
  
  &:last-child {
    margin-right: 0;
    margin-bottom: 0;
  }
  
  @media (max-width: 1370px) { 
    width: 49%;
    margin-right: 0;
    margin-bottom: 2%;
    
    &:first-child {
      margin-right: 2%;
    }
  }
`;

const TicketsContainer = styled.ul`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

const CategoryImageCarouselWrapper = styled.div`
  position: relative;
  width: 100%;  
  margin: 5em auto;
`;

const CategoryImage = styled.figure`
  width: 100%;
  padding-bottom: 56.25%;
  background-size: cover;
  background-position: center;
  background-image: url(${props => props.theme.isRetina ? props.image['large']: props.image['medium']});
  margin-bottom: 2em;
`;

const TicketType = styled.div`
  //margin-top: 10em;
  
   @media (max-width: 1200px) {
    margin-top: ${100 / (1200 * 0.01)}vw;
    
    ${HeaderTitle} {
      font-size: ${100 / (1200 * 0.01)}vw;
    }
    
    ${TicketTypeDescription} {
      margin-top: ${78 / (1200 * 0.01)}vw;
    }
    
    ${Header} {
      margin-bottom: ${60 / (1200 * 0.01)}vw;
      
      .dingbats {
        font-size: ${88 / (1200 * 0.01)}vw;
      }
    }
    
    @media (max-width: 620px) {
      ${Ticket} {
        width: 100%;
        margin-right: 0;
        margin-bottom: 5em;
        font-size: 120%;
      }
      
      ${CategoryImageCarouselWrapper} {
        margin-top: 0;
      }
    }
    
    @media (max-width: ${props => props.theme.textScaleStopPoint}px) {
      margin-top: 5em;
      
      ${HeaderTitle} {
        font-size: 5em;
      }
      
      ${TicketTypeDescription} {
        margin-top: 3.9em;
      }
      
      ${Header} {
        margin-bottom: 3em;
        .dingbats {
          font-size: 4.4em;
        }
      }
    }
  }
`;

interface ITicketCategory {
  title?: string;
  description?: string;
  tickets?: ITicket[];
  images?: any;
}

interface Props {
  appLanguage: IAppLanguage;
  _setLanguage: any;
  page: IPage;
}

class Tickets extends React.Component<Props> {

  componentWillMount() {
    const {
      appLanguage,
      _setLanguage,
      page: {
        lang_versions,
      }
    } = this.props;

    _setLanguage({ appLanguage, lang_versions });
  }

  componentWillReceiveProps({
    appLanguage,
    page: {
      lang_versions,
    }
  }: Props) {
    const {
      _setLanguage,
    } = this.props;

    _setLanguage({ appLanguage, lang_versions });
  }

  private _renderCategoryImageCarousel = (images: any) => {
    if (images && images.length > 0) {
      const categoryCarouselSettings = {
        dots: images.length > 1,
        arrows: false,
        autoplay: images.length > 1,
        adaptiveHeight: true,
        fade: true,
        pauseOnHover: true,
        pauseOnDotsHover: true
      };

      return (
        <SimpleCarousel settings={categoryCarouselSettings}>
          {images.map((image: any, index: number) =>
            <CategoryImage key={index} image={image} />
          )}
        </SimpleCarousel>
      )
    } else {
      return null;
    }
  };

  render() {
    const {
      appLanguage: {
        code
      },
      page: {
        images,
        content_group: {
          content,
          ticket_categories
        }
      }
    } = this.props;

    const { page } = this.props;

    return (
      <div>
        <SEOTags page={page} />
        <TwoColScrollLayout>
          <TwoColStickyLayout>
            { renderImageCarousel(images) }
          </TwoColStickyLayout>
          <TwoColContentLayout>
            <FlowStripeWrapper>
              <FlowStripe animate={true} rotation={90} color={'#000000'} />
            </FlowStripeWrapper>
            <ContentWrapper>
              {Boolean(ticket_categories) &&
                <SubNavigationWrapper>
                  {ticket_categories.map((category: ITicketCategory, index: number) =>
                    <li key={index}>
                      <LinkButton href={'#'+ getHashLink(category.title)} label={category.title} />
                    </li>
                  )}
                </SubNavigationWrapper>
              }

              <ContentContainer dangerouslySetInnerHTML={{__html: content}} />

              <TicketType>
                {Boolean(ticket_categories) && ticket_categories.map((category: ITicketCategory, index: number) =>
                  <TicketCategory id={getHashLink(category.title)} key={index}>
                    <Header>
                      <HeaderTitle>{category.title}</HeaderTitle>
                    </Header>

                    {category.description &&
                      <TicketTypeDescription>
                        <ContentContainer dangerouslySetInnerHTML={{__html: category.description}} />
                      </TicketTypeDescription>
                    }

                    <TicketsContainer>
                      {category.tickets && category.tickets.length > 0 && category.tickets.map((ticket: ITicket, index: number) =>
                        <Ticket key={index}>
                          <TicketLift ticket={ticket} />
                        </Ticket>
                      )}
                    </TicketsContainer>

                    <CategoryImageCarouselWrapper>
                      { this._renderCategoryImageCarousel(category.images) }
                    </CategoryImageCarouselWrapper>
                  </TicketCategory>
                )}
              </TicketType>
            </ContentWrapper>
          </TwoColContentLayout>
        </TwoColScrollLayout>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    _setLanguage: ({appLanguage, lang_versions }: ISetLanguage) => {
      dispatch(NavigationAction.setLanguage(appLanguage, lang_versions));
    }
  }
};

export default connect(
  null,
  mapDispatchToProps
)(withRouteData(Tickets));



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/tickets/Tickets.tsx